module.exports = __webpack_public_path__ + "static/media/arrow-right-circle.c08ca872.svg";